import React from 'react';

export function openCalendar(ref: React.RefObject<HTMLInputElement>) {
    if (ref.current) {
        ref.current.focus();
        ref.current.click();
        return true;
    }
    return false;
}
